import { Observable } from 'rxjs';
import { ConnectorData } from '../models/connector-data.model';

export abstract class ConnectorApiPort {
  abstract getConnectorData(): Observable<ConnectorData>;
}
